<p class="text-muted mt-3 mb-2">
    Max FOO is the overhead rate if the current overhead employees charged all of their time to overhead. Wages are the full paycheck for
    earnings codes 1-29, and liabilities are each employee's full payroll liabilities rather than the amounts posted on those charge lines.
    Labor Related, Other, and non-labor estimating (8020, 8030, 8040) are the same general ledger amounts as Charged FOO. This rate is
    current year to date only, because the employee department and position come from the current employee record.
    @if (closedLabel) {
        Closed through {{ closedLabel }}.
    }
</p>

@if (loadError) {
    <p class="text-danger">{{ loadError }}</p>
}

@if (year) {
    <div class="row mt-2">
        <div class="col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="text-muted">Max FOO {{ year }} YTD</div>
                    <strong>{{ totalPercent == null ? '—' : (totalPercent | percent: '1.2-2') }}</strong>
                    <div class="text-muted small">
                        {{ totalCost | currency: 'USD' : 'symbol' : '1.0-0' }} / {{ revenue | currency: 'USD' : 'symbol' : '1.0-0' }}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="text-muted">Charged FOO {{ year }} YTD</div>
                    <strong>{{ chargedTotalPercent == null ? '—' : (chargedTotalPercent | percent: '1.2-2') }}</strong>
                    <div class="text-muted small">
                        {{ chargedTotalCost | currency: 'USD' : 'symbol' : '1.0-0' }} / {{ revenue | currency: 'USD' : 'symbol' : '1.0-0' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
}

<h5 class="mt-3 mb-1">By category</h5>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <grid-export [grid]="categoryRateGrid" [name]="'Max FOO by Category'"></grid-export>
        </form>
    </div>
</div>
<wj-flex-grid
    #categoryRateGrid
    style="height: 360px"
    [isReadOnly]="true"
    [itemFormatter]="categoryFormatter"
    (initialized)="categoryGrid.initialize(categoryRateGrid)"
    (destroy)="categoryGrid.destroy()"
    [itemsSource]="categoryGrid.view"
>
    <wj-flex-grid-filter></wj-flex-grid-filter>
    <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="220"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Wages'" [binding]="'wages'" [width]="140" [format]="'c0'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Liabilities'" [binding]="'liabilities'" [width]="140" [format]="'c0'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Total Cost'" [binding]="'totalCost'" [width]="140" [format]="'c0'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'% of Revenue'" [binding]="'percent'" [width]="130" [format]="'p2'"></wj-flex-grid-column>
</wj-flex-grid>
<grid-selection-calculation [grid]="categoryRateGrid"></grid-selection-calculation>

<h5 class="mt-4 mb-1">Employees</h5>
<p class="text-muted mb-2">Who was classified into each labor category from the current employee record.</p>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-search name="maxFooEmployeeSearch" [(ngModel)]="employeeGrid.filter"></action-toolbar-search>
            <grid-export [grid]="employeeRateGrid" [name]="'Max FOO Employees'"></grid-export>
        </form>
    </div>
</div>
<wj-flex-grid
    #employeeRateGrid
    style="height: 420px"
    [isReadOnly]="true"
    (initialized)="employeeGrid.initialize(employeeRateGrid)"
    (destroy)="employeeGrid.destroy()"
    [itemsSource]="employeeGrid.view"
>
    <wj-flex-grid-filter></wj-flex-grid-filter>
    <wj-flex-grid-column [header]="'Employee'" [binding]="'employee'" [width]="110"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="200"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'PR Dept'" [binding]="'prDept'" [width]="100"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Position'" [binding]="'position'" [width]="260"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="160"></wj-flex-grid-column>
</wj-flex-grid>
<grid-selection-calculation [grid]="employeeRateGrid"></grid-selection-calculation>
